import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper, Chip, Pagination, TextField, InputAdornment, IconButton, CircularProgress, Grid, Card, CardContent } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';

function SetXD() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [minute, setMinute] = useState(0);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState(null);
    const [total, setTotal] = useState(null);
    const [kq, setKQ] = useState("");

    const [chimMoiList, setChimMoiList] = useState([]);

    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);

    function formatDateTimeFull(dateStr) {
        if (!dateStr) return "";
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    function formatDate(m) {
        if (!m) return "";
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const getBetLabel = (stateStr) => {
    if (!stateStr) return "";
    const map = { 
        "6": "LẺ", 
        "5": "CHẴN", 
        "4": "3 TRẮNG 1 ĐỎ", 
        "3": "3 ĐỎ 1 TRẮNG", 
        "2": "4 TRẮNG", 
        "1": "4 ĐỎ",

        "0011": "CHẴN",
        "0111": "LẺ",
        "0001": "3 TRẮNG 1 ĐỎ",
        "1110": "3 ĐỎ 1 TRẮNG",
        "0000": "4 TRẮNG",
        "1111": "4 ĐỎ"
    };
    return stateStr.split(" ").map(s => map[s] || s).join(", ");
};

    const formatMoney = (n) => String(n ? n : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setList30(res.data.data);
        }).catch(() => setList30(null));

        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getadmin?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                    setBet(res.data.data[0]);
                } else if (res.data.data._id) {
                    setBet(res.data.data);
                }
            }
        });
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchChimMoiList = () => {
        const codeChimMoi = `xd45ssanh${SANH_ID}`;
        axios.get(`${process.env.REACT_APP_API_URL}/auth/chimmoi?code=${codeChimMoi}`)
            .then(res => {
                if (res.data && res.data.data) {
                    setChimMoiList(res.data.data);
                }
            })
            .catch(err => {
                console.log("Không lấy được danh sách chim mồi", err);
                setChimMoiList([]);
            });
    };

    const fetchPlayerHistory = useCallback((pageNum, keyword, isSilent = false) => {
        if (!isSilent) setIsLoadingHistory(true); 
        const query = keyword ? `&username=${keyword}` : "";
        axios.get(`${process.env.REACT_APP_API_URL}/XD45s/history-all-players?sanh=${SANH_ID}&page=${pageNum}&limit=10${query}`)
            .then((res) => {
                if (res.data.success) {
                    setListPlayerHistory(res.data.data);
                    setTotalPages(res.data.totalPages || 1);
                    setPage(pageNum);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                if (!isSilent) setIsLoadingHistory(false);
            });
    }, [SANH_ID]);

    useEffect(() => {
        const silentUpdateTimer = setInterval(() => {
            fetchPlayerHistory(page, searchKeyword, true); 
        }, 3000);
        return () => clearInterval(silentUpdateTimer);
    }, [page, searchKeyword, fetchPlayerHistory]);

    const handleSearch = () => { setPage(1); fetchPlayerHistory(1, searchKeyword, false); };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getadmin?sanh=${SANH_ID}`).then((res) => {
            let currentBet = null;
            if (res.data && res.data.data) {
                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                    currentBet = res.data.data[0];
                } else if (res.data.data._id) {
                    currentBet = res.data.data;
                }
            }

            if (currentBet) {
                setBet(currentBet);
                setDulieunhap(new Date(currentBet.createdAt));
                setStart(true);
            }
        }).catch((err) => console.log("Chờ phiên mới..."));

        axios
            .get(`${process.env.REACT_APP_API_URL}/xd45s/getallbet?sanh=${SANH_ID}`, {})
            .then((res) => {
                if (res.data && res.data.data) setTotal(res.data.data);
            })
            .catch(() => setTotal(null));

        reloadHistorySilently();
        fetchCurrentBets(); 
        fetchChimMoiList();
        fetchPlayerHistory(1, "", false); 
    };

    useEffect(() => {
        setBet(null);
        setCurrent(null);
        setList30(null);
        fetchNewSessionAdmin();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            let remaining = 45 - diffInSeconds; // XD 45s

            if (remaining > 45) remaining = 45;

            if (remaining <= 0) {
                setSecond(0);
                setMinute(0);
                fetchNewSessionAdmin();
            } else {
                setMinute(Math.floor(remaining / 60));
                setSecond(remaining % 60);
            }
        }, 500);

        return () => clearInterval(timer);
    }, [dulieunhap, SANH_ID]);

    useEffect(() => {
        const pollInterval = setInterval(() => {
            fetchCurrentBets();
        }, 1500);
        return () => clearInterval(pollInterval);
    }, [SANH_ID]);

    const handleQuickSubmit = (resultString) => {
        if (!bet) return;
        const cleanResult = resultString.replace(/[^01]/g, '');
        const formData = {
            id_bet: bet._id,
            result: cleanResult,
            sanh: SANH_ID
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/xd45s/update`, formData)
            .then((res) => {
                swal(t('success'), "Đã set kết quả thành công!", "success");
                reloadHistorySilently();
            })
            .catch((res) => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    const handleManualSubmit = (e) => {
        e.preventDefault();
        if (!bet || !kq) return;

        const cleanKq = kq.replace(/[^01]/g, '');
        if (cleanKq.length !== 4) {
            swal("Lỗi", "Vui lòng nhập đúng 4 vị (Ví dụ: 0011)", "warning");
            return;
        }

        handleQuickSubmit(cleanKq);
        setKQ("");
    };

    const handleUpdateFutureBet = (e, item) => {
        e.preventDefault();
        const rawVal = e.target.result.value;
        if (!rawVal) return;

        const cleanHistoryKq = String(rawVal).replace(/[^01]/g, '');
        if (cleanHistoryKq.length !== 4) {
            swal("Lỗi", "Vui lòng nhập đúng 4 vị (Ví dụ: 0011)", "warning");
            return;
        }

        const formData = {
            id_bet: item._id,
            result: cleanHistoryKq, 
            sanh: SANH_ID
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/xd45s/update`, formData)
            .then((res) => {
                swal(t("success"), "Đã set kết quả cho phiên " + item.id_bet, "success");
                e.target.reset();
                reloadHistorySilently();
            })
            .catch(() => swal(t("error"), "Lỗi kết nối", "error"));
    };

    function thongke(num) {
        if (current && current.length > 0) {
            const countTable = {};
            for (let i = 1; i <= 9; i++) {
                countTable[i] = { count: 0, totalMoney: 0 };
            }
            current.forEach((item) => {
                const money = item.money;
                const states = item.state.split(" ").map(Number);
                const length = states.length;

                states.forEach((state) => {
                    if (state >= 1 && state <= 9) {
                        countTable[state].count++;
                        countTable[state].totalMoney += money / length;
                    }
                });
            });
            return Number(countTable[num].totalMoney).toLocaleString("vi-VN");
        } else {
            return 0;
        }
    }

    const currentSessionData = list30?.find(item => item.id_bet === bet?.id_bet);
    const displayResult = currentSessionData?.result || bet?.result;

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {profile?.permission?.set == 1 ? (
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 1
                            }}>
                            <Container maxWidth={false}>
                                <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
                                    {[1, 2, 3, 4, 5, 6].map((sanhId) => (
                                        <Button
                                            key={sanhId}
                                            variant={SANH_ID === sanhId ? "contained" : "outlined"}
                                            color="primary"
                                            onClick={() => navigate(`?sanh=${sanhId}`)}
                                            sx={{ fontWeight: 'bold', minWidth: '100px' }}
                                        >
                                            SẢNH {sanhId}
                                        </Button>
                                    ))}
                                </Box>

                                <div className="container_set">SẢNH {SANH_ID} - XD 45s</div>

                                <div className="cycle_bet">
                                    {bet ? (
                                        <span style={{ color: "black" }} className="info_bet">
                                            {t("session")} {bet.id_bet}
                                        </span>
                                    ) : (
                                        <span>{t("waiting")}</span>
                                    )}
                                    <div style={{ color: "black" }} className="count">
                                        0{minute} : {second < 10 ? "0" : ""}{second >= 0 ? second : 0}
                                    </div>
                                </div>
                                <div className="form_set"></div>

                                <div className="current_bet" style={{ paddingBottom: '10px' }}>
                                    <div className="current_bet_head">
                                        <div>{t("single")} (Lẻ)</div>
                                        <div>{t("double")} (Chẵn)</div>
                                        <div>{t("3w1r")} (3 Trắng 1 Đỏ)</div>
                                        <div>{t("3r1w")} (3 Đỏ 1 Trắng)</div>
                                        <div>{t("4w")} (4 Trắng)</div>
                                        <div>{t("4r")} (4 Đỏ)</div>
                                    </div>

                                    <div className="current_bet_body">
                                        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(6)}</div>
                                        <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(5)}</div>
                                        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(4)}</div>
                                        <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(3)}</div>
                                        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(2)}</div>
                                        <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(1)}</div>
                                    </div>

                                    <div className="current_bet_body" style={{ marginTop: '10px', alignItems: 'center' }}>
                                        <div>
                                            <Button variant="contained" color="secondary" size="small" onClick={() => handleQuickSubmit("0111")} title="3 Đỏ 1 Trắng (Lẻ)">LẺ</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="success" size="small" onClick={() => handleQuickSubmit("0011")} title="2 Trắng 2 Đỏ (Chẵn)">CHẴN</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="info" size="small" onClick={() => handleQuickSubmit("0001")} title="3 Trắng 1 Đỏ">SET</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="warning" size="small" onClick={() => handleQuickSubmit("0111")} title="3 Đỏ 1 Trắng">SET</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" sx={{ bgcolor: '#e0e0e0', color: 'black', '&:hover': { bgcolor: '#d5d5d5' } }} size="small" onClick={() => handleQuickSubmit("0000")} title="4 Trắng (Chẵn)">SET</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="error" size="small" onClick={() => handleQuickSubmit("1111")} title="4 Đỏ (Chẵn)">SET</Button>
                                        </div>
                                    </div>
                                </div>

                                <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1, boxShadow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div style={{ color: "black", marginBottom: '15px', textAlign: 'center' }} className="result_admin_choose">
                                        {t("result_recent")} (Kết quả hiện tại):{" "}
                                        {bet ? (
                                            <span style={{ fontWeight: "600", color: "red", fontSize: '18px' }}>
                                                {displayResult && displayResult.trim() !== "" ? displayResult : "Chưa có"}
                                            </span>
                                        ) : (
                                            <span>{t("waiting")}</span>
                                        )}
                                    </div>

                                    <form onSubmit={handleManualSubmit} style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{t("edit_result")} (Nhập tay): </span>
                                        <input
                                            value={kq}
                                            onChange={(e) => setKQ(e.target.value)}
                                            type="text"
                                            placeholder="VD: 0011"
                                            style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', width: '200px', fontSize: '16px', fontWeight: 'bold', letterSpacing: '2px' }}
                                        />
                                        <Button type="submit" variant="contained" color="primary">{t("submit")}</Button>

                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => window.location.reload(true)}
                                        >
                                            {t("refresh")}
                                        </Button>
                                    </form>
                                </Box>

                                <Paper elevation={3} sx={{ mt: 4, mb: 4, borderRadius: 2, overflow: 'hidden' }}>
                                  
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: '#fff3e0' }}>
                                                <TableCell style={{ fontWeight: 'bold', width: '10%' }}>STT</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '20%' }}>ID User</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '40%' }}>Tài Khoản</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '30%' }}>Mã Lệnh Đang Ép</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {chimMoiList && chimMoiList.length > 0 ? (
                                                chimMoiList.map((item, idx) => (
                                                    <TableRow key={idx} hover>
                                                        <TableCell style={{ fontWeight: 'bold' }}>{idx + 1}</TableCell>
                                                        <TableCell>{item.iduser}</TableCell>
                                                        <TableCell style={{ color: '#1976d2', fontWeight: 'bold' }}>{item.username}</TableCell>
                                                        <TableCell style={{ color: 'red', fontWeight: 'bold' }}>{item.win}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                    <TableCell colSpan={4}>Không có Chim Mồi nào được cài ở sảnh này.</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Paper>

                                <div className="form_set" style={{ marginTop: '20px' }}>
                                   
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold', width: '10%' }}>ID</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '25%' }}>{t('username')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '20%' }}>{t('selected')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '20%' }}>{t('money')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '25%' }}>Thời gian cược</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {current && current.length > 0 ? (
                                                    current.map((item, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell>{item?.user?.iduser}</TableCell>
                                                            <TableCell>{item?.user?.username}</TableCell>
                                                            <TableCell>
                                                                <span style={{ fontWeight: 'bold', color: '#e53935' }}>
                                                                    {getBetLabel(item.state)}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>
                                                                <span style={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                                                    {Number(item.money).toLocaleString("vi-VN")}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                        <TableCell colSpan={5}>{t("no_player")}</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>

                               
                                <div className="form_set" style={{ marginTop: '20px' }}>
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }}>STT</TableCell>
                                                    <TableCell>{t('session')}</TableCell>
                                                    <TableCell>{t('result')}</TableCell>
                                                    <TableCell>{t('update')} (Sửa lịch sử/Tương lai)</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{t('time')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {list30 && bet ? list30
                                                    .filter((item) => {
                                                        if (!bet || !bet.id_bet) return true;
                                                        return Number(item.id_bet) >= Number(bet.id_bet);
                                                    })
                                                    .sort((a, b) => Number(a.id_bet) - Number(b.id_bet))
                                                    .map((item, idx) => {
                                                        const isCurrent = item.id_bet === bet?.id_bet;
                                                        return (
                                                            <TableRow
                                                                key={item._id || idx}
                                                                sx={{ bgcolor: isCurrent ? '#fff9c4' : 'inherit' }}
                                                            >
                                                                <TableCell style={{ fontWeight: 'bold', color: isCurrent ? 'red' : '#1976d2' }}>
                                                                    {isCurrent ? "Đang chạy" : `${idx}`}
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: isCurrent ? 'bold' : 'normal' }}>
                                                                    {item?.id_bet}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <span style={{ fontWeight: isCurrent ? 'bold' : 'normal', color: isCurrent ? 'red' : 'inherit', fontSize: isCurrent ? '16px' : 'inherit', letterSpacing: '2px' }}>
                                                                        {item.result}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <form
                                                                        style={{ display: 'flex', gap: '5px' }}
                                                                        onSubmit={(e) => handleUpdateFutureBet(e, item)}
                                                                    >
                                                                        <input
                                                                            name="result"
                                                                            type="text"
                                                                            placeholder="VD: 0011"
                                                                            style={{ width: '80px', padding: '5px', border: isCurrent ? '1px solid red' : '1px solid #ddd', borderRadius: '4px', letterSpacing: '1px' }}
                                                                        />
                                                                        <button className="btn-admin-3" style={{ padding: '5px 10px', cursor: 'pointer' }}>
                                                                            {t("submit")}
                                                                        </button>
                                                                    </form>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: "center" }}>
                                                                    {formatDateTimeFull(item.createdAt)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                    : null}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>
                            </Container>
                        </Box>
                    ) : (
                        <div style={{ padding: 20, textAlign: 'center' }}>{t("not_permission")}</div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default SetXD;